export default "__VITE_ASSET__CJxORZHM__"